/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileMemberResponse } from '../../models/profile-member-response';

export interface GetProfileMembers$Params {
  id: number;
}

export function getProfileMembers(http: HttpClient, rootUrl: string, params: GetProfileMembers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileMemberResponse>>> {
  const rb = new RequestBuilder(rootUrl, getProfileMembers.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileMemberResponse>>;
    })
  );
}

getProfileMembers.PATH = '/rest/profile/{id}/members';
